import { Component, inject } from '@angular/core';
import { ContextService } from '../../../core/services/context.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-service-meta',
  standalone: true,
  template: `
    <div class="px-4 py-4 text-xs text-white/65">
      <div class="flex items-center justify-between">
        <span class="font-bold text-red-300 text-xs">{{ envName }}</span>
        <span class="h-2 w-2 rounded-full bg-maersk-success"></span>
      </div>
      @if (contextService.serviceMeta(); as meta) {
        <div class="mt-1">API {{ meta['application_version'] }}</div>
      }
    </div>
  `,
})
export class ServiceMetaComponent {
  readonly contextService = inject(ContextService);
  readonly envName = environment.environmentName;
}
